// Utility to extract generic CTA sections (e.g., <section id="question">) and replace with a placeholder
// Returns: { html: string, ctaGenericData: any | null }

export interface ProcessedCTAGenericResult {
  html: string;
  ctaGenericData: any | null;
}

export function processCTAGeneric(html: string): ProcessedCTAGenericResult {
  if (!html || typeof html !== 'string') return { html, ctaGenericData: null };

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const section = doc.querySelector('#question');
    let ctaGenericData = null;
    if (section) {
      const script = section.querySelector('script[type="application/json"]');
      if (script && script.textContent) {
        let jsonText = script.textContent.trim();
        // Optionally fix single quotes to double quotes for JSON validity
        jsonText = jsonText.replace(/'/g, '"');
        try {
          ctaGenericData = JSON.parse(jsonText);
        } catch (e) {
          ctaGenericData = null;
        }
      }
      if (ctaGenericData) {
        section.replaceWith(document.createComment('CTAGENERIC_PLACEHOLDER'));
        return {
          html: doc.body.innerHTML,
          ctaGenericData
        };
      }
    }
    return { html, ctaGenericData: null };
  } catch (error) {
    return { html, ctaGenericData: null };
  }
}
